import React from "react";
import deadSeaFacialImg from "./../../../../Images/FacialPage/Dead Sea Mineral Facial.png";

const DeadSeaFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={deadSeaFacialImg} alt="deadSeaFacialImg" />
    </div>
  );
};

export default DeadSeaFacialImg;
